import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

export default function NotFound() {
  return (
    <Layout>
      <section className="section not-found">
        <div className="container container--narrow center">
          <p className="eyebrow">Error 404</p>
          <h1>This branch of the tree is missing</h1>
          <p>The page you were looking for may have moved. Try the home page, our troubleshooting finder, or the guide library.</p>
          <div className="actions actions--center">
            <Link to="/" className="btn btn--dark">
              Back to home
            </Link>
            <Link to="/guides" className="btn btn--outline">
              Browse guides
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
